import styled from 'styled-components/macro';

export const DateSpan = styled.span`
  color: #f3daad;
`;
